export type EventCircleVisibility =
  | "PRIVATE"
  | "PUBLIC";

export type EventCircleStatus =
  | "ACTIVE"
  | "CANCELLED";

export type EventCircleResponse =
  | "HOST"
  | "AWAITING"
  | "GOING"
  | "MAYBE"
  | "BUSY"
  | "NOT_GOING";

/* Old name is kept so existing files still compile. */
export type RecipientType =
  | "USERNAME"
  | "PHONE";

export type InvitationRecipientType =
  RecipientType;

export type EventCircleRecipient = {
  recipientType: RecipientType;
  recipient: string;
};

export type EventCircle = {
  circleId: string;
  title: string;
  description: string;
  location: string;
  startsAt: number;
  endsAt: number;
  visibility: EventCircleVisibility;
  status: EventCircleStatus;
  editCount: number;
  updatedAt: number;
  isHost: boolean;
  responseStatus: EventCircleResponse;
  shareable: boolean;
  token?: string;
  invitationId?: string;
};

export type EventCircleDashboard =
  EventCircle & {
    going: number;
    maybe: number;
    busy: number;
    notGoing: number;
    awaiting: number;
  };

/*
 * recipients is the new multi-invite format.
 * recipientType + recipient remain supported for
 * your older EventCircleForm and Composer files.
 */
export type CreateEventCircleInput = {
  title: string;
  description: string;
  location: string;
  startsAt: number;
  endsAt: number;
  allDay?: boolean;
  timeZone?: string;
  addToCountdown?: boolean;
  visibility: EventCircleVisibility;

  recipients?: EventCircleRecipient[];

  recipientType?: RecipientType;
  recipient?: string;
};

export type UpdateEventCircleInput = {
  circleId: string;
  title: string;
  description: string;
  location: string;
  startsAt: number;
  endsAt: number;
};

export type InviteeResponse = Exclude<
  EventCircleResponse,
  "HOST" | "AWAITING"
>;

export const eventCircleResponses: Array<{
  value: InviteeResponse;
  label: string;
}> = [
  {
    value: "GOING",
    label: "Going",
  },
  {
    value: "MAYBE",
    label: "Maybe",
  },
  {
    value: "BUSY",
    label: "Busy",
  },
  {
    value: "NOT_GOING",
    label: "Not going",
  },
];

export function responseLabel(
  response: EventCircleResponse,
): string {
  switch (response) {
    case "HOST":
      return "Host";

    case "GOING":
      return "Going";

    case "MAYBE":
      return "Maybe";

    case "BUSY":
      return "Busy";

    case "NOT_GOING":
      return "Not going";

    default:
      return "Awaiting response";
  }
}

export function editLabel(
  editCount: number,
): string {
  if (editCount <= 0) {
    return "Original event";
  }

  if (editCount === 1) {
    return "Edited";
  }

  return `${editCount} edits`;
}

export function formatEventDateTime(
  timestamp: number,
): string {
  return new Intl.DateTimeFormat(
    "en-MY",
    {
      weekday: "short",
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
    },
  ).format(new Date(timestamp));
}